"use strict";
import "lodash";
import { svc_getOutlets, svc_getOutletsFull } from "@/services/outlets";
import { svc_fetchOne, svc_addOne, svc_editOne, svc_deleteOne } from "@/services";
import { showServerResponse } from "@/utils/message";
import logger from "@/utils/logger";

const endpointBasePrefix = "outlets";

const Model = {
	namespace: "m_Outlets",
	state: {
		outlets: [],
		selectedGlobalOutlet: {},
	},
	reducers: {
		handleFetchAll(state, { payload: { outlets } }) {
			return { ...state, outlets };
		},
		saveGlobalOutlet(state, { payload: { selectedGlobalOutlet } }) {
			return { ...state, selectedGlobalOutlet };
		},
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			// if its a object, set the object to brand id
			let outlets = yield call(svc_getOutlets, payload);
			_.forEach(outlets, function (row) {
				row.key = row.id;
				row.fullAddress = `${row.primary_address_line}, ${row.secondary_address_line}`
			});

			yield put({
				type: "handleFetchAll",
				payload: { outlets },
			});

			return outlets;
		},
		*fetchAllUpos({ payload }, { call, put }) {
			// if its a object, set the object to brand id
			if (payload.brand_id) payload = payload.brand_id;
			if (payload.upos_brand_id) payload = payload.upos_brand_id;
			// if (payload.brand_id) payload = payload.brand_id;
			let outlets = yield call(svc_getOutlets, payload);
			_.forEach(outlets, function (row) {
				row.key = row.id;
			});

			yield put({
				type: "handleFetchAll",
				payload: { outlets },
			});
			
			return outlets;
		},
		*fetchAllFull({ payload }, { call, put }) {
			let outlets = yield call(svc_getOutletsFull, payload);
			_.forEach(outlets, function (row) {
				row.key = row.id;
			});

			yield put({
				type: "handleFetchAll",
				payload: { outlets },
			});

			return outlets;
		},
		*updateGlobalSelectedOutlet({ payload }, { call, put }) {
			let selectedGlobalOutlet = { id: null };
			if (payload) selectedGlobalOutlet = yield call(svc_fetchOne, endpointBasePrefix, payload);

			// reset back to default if unknown value
			if (!selectedGlobalOutlet)
				selectedGlobalOutlet = { id: null };

			// save to model state for consistency
			yield put({
				type: "saveGlobalOutlet",
				payload: { selectedGlobalOutlet },
			});

			// save to localstorage for local persistency
			localStorage.setItem("selectedGlobalOutlet", JSON.stringify(selectedGlobalOutlet));

			return selectedGlobalOutlet;
		},
		*fetchGlobalSelectedOutlet({ }, { call, put }) {
			let searchKey;
			let selectedGlobalOutlet = { id: null };
			let savedGlobalOutlet = JSON.parse(localStorage.getItem("selectedGlobalOutlet"));
			if (savedGlobalOutlet)
				searchKey = savedGlobalOutlet["id"];

			if (searchKey) {
				// always fetch for updates on this outlet
				selectedGlobalOutlet = yield call(svc_fetchOne, endpointBasePrefix, searchKey);
			} else {
				selectedGlobalOutlet = savedGlobalOutlet;
			}

			// reset back to default if unknown value
			if (!selectedGlobalOutlet)
				selectedGlobalOutlet = { id: null };

			// save to model state for consistency
			yield put({
				type: "saveGlobalOutlet",
				payload: { selectedGlobalOutlet },
			});

			// save to localstorage for local persistency
			localStorage.setItem("selectedGlobalOutlet", JSON.stringify(selectedGlobalOutlet));

			return selectedGlobalOutlet;
		},
		*addOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_addOne, endpointBasePrefix, payload, payload.name);
			return showServerResponse(response);
		},
		*editOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_editOne, endpointBasePrefix, payload, "id", payload.name);
			return showServerResponse(response);
		},
		*deleteOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_deleteOne, endpointBasePrefix, payload, "id", payload.name);
			return showServerResponse(response);
		},
	},
	subscriptions: {},
};

export default Model;
